import React from 'react';
import { Badge, Label } from '@nooz-optics/nooz-components-lib';
import { Button, Radio } from '../../../../../UI/Elements';
import { Image } from '../../../../../UI/Media';

export const ProductPackOption = ({ category, onClick, product }) => {
  const diopterValue = product.shopifyVariants[0].selectedOptions.diopter;
  return (
    <button
      className='flex h-full justify-start flex-row items-center cursor-pointer'
      type='button'
      onClick={onClick}>
      <div className='w-1/2 pl-2'>
        <Image
          {...product.variant.images[0]}
          width='100%'
          height='100%'
        />
      </div>
      <div className='w-1/2 flex justify-center flex-col pr-2'>
        <Badge
          size='sm'
          type='white'
          dotColor={category?.color}
          label={category?.label}
        />
        <div className='mt-2 text-left'>
          <Label
            {...product.product.label}
            truncate
            size='3xl'
          />
        </div>
        <div className='flex mt-2'>
          <Radio
            size='base'
            color={product?.variant?.color?.hex}
          />
          {diopterValue && diopterValue !== '0' && (
            <div className='ml-2'>
              <Button
                size='xs'
                label={{
                  text: diopterValue,
                }}
                type='white'
              />
            </div>
          )}
        </div>
      </div>
    </button>
  );
};

export const ProductPackOptionTrigger = ({ button, onClick, category }) => (
  <button
    type='button'
    onClick={onClick}
    className='flex-1 bg-gray-100 h-48 lg:h-full hover:bg-gray-50 cursor-pointer flex items-center justify-center'>
    <Button
      {...button}
      type='contained'
      size='base'
      color={category?.color}
      onClick={onClick}
    />
  </button>
);
